export default {"src":"/_next/static/media/ApprovalFlowImage.7c539021.svg","height":185,"width":556,"blurWidth":0,"blurHeight":0};